import React, {useEffect, useState} from 'react';
import './App.scss';
import {
    Alert, AppBar,
    Avatar,
    Box, Breadcrumbs,
    Button,
    Card,
    CardContent,
    Chip,
    Container, Divider, Grid, Link,
    TextField,
    Typography
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import HelloImage from './images/hello.gif';

interface fanMedal {
    _id?: string,
    aid?: number|string,
    room?: string|number,
    level: number,
    name: string,
    anchor?: string,
    _time: string|Date,
    _oid?: string
}

interface User {
    uid: number | string,
    name: string,
    avatar: string,
    success: number,
    fanMedals: Record<string,fanMedal>,
    updated?: number
}

function formatDate(date: string | Date | number, type=0) {
    if (date==='') { return '' }
    if(!(date instanceof Date)){
        date = new Date(date);
    }
    if (type===2) {
        return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    } else if (type===1) {
        return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    }
    return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/*const demo = [
    {
        "room": 263605,
        "level": 40,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 36,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 32,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 28,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 24,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 20,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 16,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 12,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 8,
        "name": "☆196",
        "aid": "5055"
    },
    {
        "room": 263605,
        "level": 4,
        "name": "☆196",
        "aid": "5055"
    }
]*/

function App() {
    const [loading, setLoading] = useState(false);
    const [uname, setUname] = useState("");
    const [user, setUser] = useState<User>();
    const [medals, setMedals] = useState<fanMedal[]>([]);
    const [lastUpdate, setLastUpdate] = useState("");
    const [msg, setMsg] = useState<string|null>(null);
    const [route, setRoute] = useState(1);

    /*const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));*/
    const isMobile = true;

    useEffect(() => {
        setLastUpdate("");
        if (user && user.fanMedals) {
            if (user.fanMedals._time) {
                setLastUpdate(formatDate(String(user.fanMedals._time),2));
                delete user.fanMedals._time;
            }
            let sortMedals: [number, fanMedal][] = [];
            for (const anchorId in user.fanMedals) {
                user.fanMedals[anchorId].aid = anchorId;
                sortMedals.push([user.fanMedals[anchorId].level, user.fanMedals[anchorId]]);
            }
            sortMedals.sort((a: [number, fanMedal], b: [number, fanMedal]) => {
                return b[0] - a[0];
            });
            let medals:fanMedal[] = [];
            for (let i = 0; i < sortMedals.length; i++) {
                medals.push(sortMedals[i][1]);
            }
            setMedals(medals);
        }
    }, [user]);

    const handleSearch = () => {
        setMsg(null);
        if(uname) {
            setLoading(true);
            let apiUrl = (route === 2) ? `api.xym.hk` : `api.yukari.top`;
            fetch(`https://${apiUrl}/users/fanMedals?username=${uname}&ts=${Date.now()}`)
                .then((response) => response.json())
                .then((data) => { if (data.error > 0) { setMsg(data.message); } else { setUser(data); } setLoading(false) })
                .catch((e) => { setMsg('出错咯！请稍后再试，或联系香香。'); setLoading(false); });
        }
    }

    const handleChangeRoute = () => {
        if (route===2) {
            setRoute(1);
        } else {
            setRoute(2);
        }
    }


    return (
        <Box>
            <AppBar position="static" color={'default'} sx={{px:2,py:1}}>
                <Breadcrumbs separator="＞">
                    <Link underline="hover" color="inherit" href="/">
                        <Chip label="XY FAN LAB"  sx={{cursor:"pointer"}} />
                    </Link>
                    <Typography color="text.primary">粉丝牌查询</Typography>
                </Breadcrumbs>
            </AppBar>
        <Container maxWidth={'md'}>
            <Box sx={{my:2,textAlign:'center'}}>
                <Box sx={{textAlign:'right'}}>如搜索出错可试试切换线路：<Button onClick={handleChangeRoute} variant={'contained'} color={(route===2)?'secondary':'warning'}>线路{route}</Button></Box>
                <img alt={'你是不是喜欢我'} src={HelloImage} />
                <TextField
                    required
                    id="searchUser"
                    label="搜索"
                    placeholder="请输入B站用户名"
                    onChange={(e) => setUname(e.target.value)}
                    fullWidth={true}
                    sx={{mb:2,background:'#FFF'}}
                />
                <LoadingButton
                    onClick={handleSearch}
                    loading={loading}
                    variant="contained"
                    sx={{width: '100%'}}
                >
                    搜索小呆毛
                </LoadingButton>
                { msg && (
                    <Alert severity="info">{msg}</Alert>
                )}
            </Box>

            { user && (
                <Card className={"bg"}>
                    <CardContent sx={{textAlign: (isMobile)?'center':'left'}}>
                        <Box sx={{justifyContent:(isMobile)?'center':'left',alignItems:(isMobile)?'center':'left', display: "flex"}}><Avatar alt={user.name} src={'https:'+user.avatar} sx={{width:'8rem', height:'8rem'}}/></Box>
                        <Typography variant={'h4'}>{user.name}</Typography>
                        <Typography variant={'h6'}><Chip label={<Typography variant="h6" component="span">UID：{user.uid}</Typography>} sx={{my:1}} /></Typography>
                        <Divider sx={{my:2}} />
                        <Box><Chip label={<Typography variant="body1" component="span">最后更新：{lastUpdate}</Typography>} sx={{my:.5}} /></Box>
                        <Grid container spacing={3}>
                        {
                           medals && medals.map((m, idx) => (
                                <Grid item xs={12} sm={6} md={4} key={`medal-${idx}`}>
                                    <Link href={(m.room) ? `https://live.bilibili.com/${m.room}` : `https://space.bilibili.com/${m.aid}`} target={'_blank'} title={(m.room) ? `直播间：${m.room}`:`主播/UP主：${m.aid}`}>
                                    <Typography variant={'h5'} component={'span'} sx={{m:[0.5,1,2],display:"inline-block"}}>
                                    <Box className={`medal level-${m.level}`}>
                                        <Box className={`medal level-${m.level}`} sx={{py:1,px:3,color:"#FFF !important"}}>{m.name}</Box><Box sx={{background:'#FFF',p:1,display:"inline-block"}} component={'span'}>{m.level}</Box>
                                    </Box>
                                    </Typography>
                                    </Link>
                                    {/*{
                                        m.room && (
                                            <Box><Chip label={<>（直播间：{m.room}）</>} /></Box>
                                        )
                                    }*/}
                                    {
                                        m.anchor && (
                                            <Box><Chip label={<>（主播/UP主：{m.anchor}）</>} /></Box>
                                        )
                                    }
                                </Grid>
                            ))
                        }
                        </Grid>
                        <Box sx={{mt:3}}>
                        <Typography variant={'subtitle1'} sx={{px:.5}}>*只会展示曾经在196直播间佩戴过的粉丝勋章</Typography>
                        <Typography variant={'subtitle1'} sx={{px:.5}}>*等级数据会以196的弹幕、礼物、SC、进入直播间统计</Typography>
                        <Typography variant={'subtitle1'} sx={{px:.5}}>*搜索每个小呆毛24小时内只会更新一次</Typography>
                        </Box>
                    </CardContent>
                </Card>
            )}
            <Box sx={{mt:5,textAlign:'center'}}>
                <Box>&copy; XIAO YUAN FAN LAB</Box>
                <a href={'https://xiaoyuan.club/'} target={'_blank'} rel="noreferrer" ><img src={'https://xiaoyuan.club/badge.png'} alt={'小缘粉丝俱乐部'} /></a>
                <Box>Powered by 小缘粉丝俱乐部</Box>
            </Box>
        </Container>
        </Box>
    );
}

export default App;
